import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormGroup, Validators} from '@angular/forms';
import {RodzajPowierzchni} from '../../../../../../../../../services/slownik/types/rodzaj-powierzchni';
import {MaterialWykonczenia} from '../../../../../../../../../services/slownik/types/material-wykonczenia';
import {Subscription} from 'rxjs';

@Component({
  selector: 'shared-formularz',
  templateUrl: './formularz.component.html'
})

export class FormularzComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  formularzId?: string;

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  @Input()
  formularzWidoczny = false;

  @Input()
  rodzajePowierzchni: RodzajPowierzchni[] = [];

  @Input()
  rodzajeMaterialowWykonczenia: MaterialWykonczenia[] = [];

  @Input()
  czyPosiadaAtrybuty = true;

  @Input()
  czyWalidacjaWgPowierzchni = false;

  @Input()
  pokazWartosc = false;

  @Input()
  pokazKomentarz = false;

  @Input()
  pokazFolieReklamowa = false;

  @Input()
  minimalnaWartoscUszkodzenia!: number;

  @Input()
  maksymalnaWartoscUszkodzenia!: number;

  @Input()
  domyslnaWartoscUszkodzenia!: number | null;

  @Input()
  pokazSzerokosc = false;

  @Input()
  pokazWysokosc = false;

  @Input()
  etykietaWartosci = '';

  @Input()
  pokazWyczyscElement = true;

  @Input()
  minimalnaWysokosc!: number;

  @Input()
  maksymalnaWysokosc!: number;

  @Input()
  minimalnaSzerokosc!: number;

  @Input()
  maksymalnaSzerokosc!: number;

  @Input()
  jednostkaPowierzchniUszkodzenia!: string;

  @Output()
  wyczyscFormularz = new EventEmitter<string>();

  @Output()
  zmianaFormularza = new EventEmitter<{id: string | undefined, formGroup: UntypedFormGroup}>();

  private zmianaFormularzaSubscription: Subscription | undefined;

  wyczyscElement(): void {
    this.wyczyscFormularz.emit(this.formularzId)
  }

  ngOnInit(): void {
    this.zmianaFormularzaSubscription = this.formularzUszkodzenia?.valueChanges.subscribe(() =>
      this.zmianaFormularza.emit({id: this.formularzId, formGroup: this.formularzUszkodzenia})
    )
  }

  ngOnDestroy(): void {
    this.zmianaFormularzaSubscription?.unsubscribe()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.czyPosiadaAtrybuty) {
      const {formularzWidoczny} = changes;
      if (formularzWidoczny) {
        this.toggleValidity(formularzWidoczny.currentValue ? formularzWidoczny.currentValue : false);
      }
    }
  }

  private toggleValidity(change: boolean): void {
    const { controls } = this.formularzUszkodzenia
    if (change) {
      Object.keys(controls).forEach(key => controls[key].clearValidators())
    } else {
      Object.keys(controls).forEach(key => controls[key].setValidators([Validators.required]))
    }
    setTimeout(() => {
      Object.keys(controls).forEach(key => controls[key].updateValueAndValidity())
      this.zmianaFormularza.emit({id: this.formularzId, formGroup: this.formularzUszkodzenia})
    })
  }
}
